export const Colors = {
    blue_navy: "#0096D2",
    blue_royal: "#003C78",
    green: "#64B400",
    red: "#E10019",
    orange: "#F5821F",
    grey_prim: "#919191",
    grey_bg_dark: "#E4E4E4",
    grey_lines: "#D7D7D7",
    grey_bg_light: "#F2F2F2",
    header_dark_blue: "#002D5F",
    header_dark_black: "#000",
  };
  